import * as _ from "lodash";
import beneficiaryTypeCodes from "../common/constants/beneficiaryTypeCodes";
import saveChangesModalTemplate from "../module/beneficiary/view/saveChanges/saveChangesModalTemplate";
import saveChangesController from "../module/beneficiary/view/saveChanges/saveChangesController";

var beneficiaryService = function ($modal) {
    var records = [];
    var fromUrl;
    var originState = null;
    var originStateParams = null;
    var showSaveDialog = false;
    var dialogLoading = false;
    var toState = null;
    var toStateParams = null;
    var profileLink = null;
    var beneAccessParams = {
        beneRAccess: null,
        beneUAccess: null,
        beneMAcess: null
    };

    return {
        getModel: function (defaultAddress) {
            var defaults = {
                address1: '',
                address2: '',
                city: '',
                state: '',
                zipCode: '',
                country: ''
            };

            // Don't trust that the defaultAddress has all of the expected fields
            defaultAddress = _.defaults(defaultAddress, defaults);

            var haveAddressOnFile =
                defaultAddress.address1 == defaults.address1 &&
                    defaultAddress.address2 == defaults.address2 &&
                    defaultAddress.city == defaults.city &&
                    defaultAddress.state == defaults.state &&
                    defaultAddress.zipCode == defaults.zipCode &&
                    defaultAddress.country == defaults.country ?
                    false : true;

            return {
                id: null,
                useAddressOnFile: haveAddressOnFile,
                beneficiaryDesignation: '',
                beneficiaryType: '',
                beneficiaryFirstName: '',
                beneficiaryMiddleName: '',
                beneficiaryLastName: '',
                beneficiarySuffix: '',
                allocationPercent: '',
                socialSecurityNumber: '',
                dateOfBirth: '',
                phoneNumber: '',
                address1: defaultAddress.address1,
                address2: defaultAddress.address2,
                city: defaultAddress.city,
                state: defaultAddress.state,
                zipCode: defaultAddress.zipCode,
                country: defaultAddress.country || { code: 'US' },
                uniqueId: this.getUniqueId()
            };
        },
        getRecord: function (recordId) {
            var index = _.findIndex(records, { 'id': recordId });

            return index >= 0 ? records[index] : null;
        },
        getRecords: function () {
            return records;
        },
        setRecords: function (newRecords) {
            records = newRecords;
        },
        add: function (record) {
            records.push(_.defaults({}, record));
        },
        getBeneficiaryName: function (beneficiary, showSuffix) {
            var name = "";

            if (this.getType(beneficiary) == beneficiaryTypeCodes.Individual) {
                // Set name to First Middle Last for individuals

                if (beneficiary.beneficiaryFirstName) {
                    name += beneficiary.beneficiaryFirstName;

                    if (beneficiary.beneficiaryMiddleName) {
                        name += " " + beneficiary.beneficiaryMiddleName;
                    }
                }

                if (name !== "") {
                    name += " ";
                }

                if (beneficiary.beneficiaryLastName) {
                    name += beneficiary.beneficiaryLastName;
                }


                if (showSuffix && beneficiary.beneficiarySuffix) {
                    name += ", " + beneficiary.beneficiarySuffix;
                }

            }
            else {
                name = beneficiary.beneficiaryLastName;
            }

            return name;
        },
        getMaritalStatusDescription: function (maritalStatusCodes, maritalStatus) {
            var index = _.findIndex(maritalStatusCodes, { 'code': maritalStatus });

            return index >= 0 ? maritalStatusCodes[index].description : '';
        },
        getUniqueId: function () {
            return _.uniqueId('beneficiary_');
        },
        getType: function (beneficiary) {
            var type = null;

            if (beneficiary && beneficiary.beneficiaryType) {
                // The first three characters of the type code will always be the type. (i.e. IND, EST, TRU, or OTH)
                type = beneficiary.beneficiaryType.substr(0, 3);
            }

            return type;
        },
        getRelationship: function (beneficiary) {
            var relationship = null;
            var type = this.getType(beneficiary);

            if (type === beneficiaryTypeCodes.Individual) {
                relationship = beneficiary.beneficiaryType.substr(4, 3);
            }
            // Otherwise this is not an individual and therefore has no relationship

            return relationship;
        },
        getTypeOrRelationshipDisplay: function (beneficiaryType, beneficiaryTypes) {
            var relation = _.result(_.find(beneficiaryTypes, { "code": beneficiaryType }), 'description');
            if (relation === undefined) {
                return 'Invalid details';
            } else {
                return _.result(_.find(beneficiaryTypes, { "code": beneficiaryType }), 'description');

            }
        },
        reset: function () {
            records = [];
        },
        setFromUrl: function (url) {
            fromUrl = url;
        },
        getFromUrl: function () {
            return fromUrl;
        },
        resetSaveChangesModal: function () {
            showSaveDialog = false;
            dialogLoading = false;
        },
        openSaveChangesModal: function (scope) {
            var modalInstance = $modal.open({
                template: saveChangesModalTemplate,
                controller: saveChangesController,
                controllerAs: 'ctrl',
                size: 'md',
                windowClass: 'auto-increase-wrapper',
                scope: scope
            });
            modalInstance.result.then(function () { }, function () {
                showSaveDialog = true;
                dialogLoading = false;
            });
        },
        setDialogLoading: function (val) {
            dialogLoading = val;
        },
        getDialogLoading: function () {
            return dialogLoading;
        },
        getShowSaveDialog: function () {
            return showSaveDialog;
        },
        setShowSaveDialog: function (val) {
            showSaveDialog = val;
        },
        setToState: function (val) {
            toState = val;
        },
        getToState: function () {
            return toState;
        },
        setToStateParams: function (params) {
            toStateParams = params
        },
        getProfileLink: function () {
            return profileLink;
        },
        setProfileLink: function (val) {
            profileLink = val;
        },
        getToStateParams: function () {
            return toStateParams;
        },
        setBeneAccessParams: function (beneRparam, beneUparam, beneMAcess) {
            beneAccessParams.beneRAccess = beneRparam;
            beneAccessParams.beneUAccess = beneUparam;
            beneAccessParams.beneMAcess = beneMAcess;
        },
        getBeneAccessParams: function () {
            return beneAccessParams;
        }
    };
};
beneficiaryService.$inject = ['$modal'];
export default beneficiaryService;
